import React from 'react';
import { CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton, Section } from './Shared';
import { FlowerOfLife, MetatronCube } from './Ornaments';
import { PRICE } from '../data/pack';
export function EmotionalClose() {
  return <Section className="max-w-4xl" data-id="element-17" data-mp="qnjh5j98xveu">
      <div className="astral-canvas relative overflow-hidden rounded-3xl border border-brand-gold/55 bg-brand-paper p-7 text-center shadow-[0_18px_50px_rgba(8,4,20,0.5)] md:p-12" data-id="element-18" data-mp="qmi63es8d8x4">
        <FlowerOfLife className="absolute -right-20 -top-20 h-64 w-64 opacity-25" color="#A98BFF" data-id="element-19" data-mp="hmbvq1rtwp26" />
        <MetatronCube className="absolute -bottom-24 -left-24 h-64 w-64 opacity-25" color="#E9C46A" data-id="element-20" data-mp="co0m9s5g4gkh" />
        <div className="relative" data-id="element-21" data-mp="7qs4vts4ggka">
          <h2 className="font-display text-2xl font-bold text-brand-ink md:text-4xl" data-id="element-22" data-mp="271rt6jwe4mc8">
            Hay dos versiones de vos en este momento.
          </h2>
          <div className="mx-auto mt-8 max-w-2xl space-y-5 text-base leading-relaxed text-brand-text md:text-lg" data-id="element-23" data-mp="220cb90pievy2">
            <p data-id="element-24" data-mp="3a1m1yi1b2i59">
              Una que cierra esta página y la próxima sesión sigue dependiendo
              únicamente de su intuición momentánea. Sin un atlas que respalde
              cada diagnóstico. Sin protocolos clínicos. Sin el material técnico
              que sus pacientes merecen ver.
            </p>
            <p className="font-semibold text-brand-teal" data-id="element-25" data-mp="3nsh132m05kvn">
              Y otra que decide que hoy es el día en que su práctica terapéutica
              sube de nivel para siempre.
            </p>
          </div>
          <div className="mx-auto mt-10 max-w-md rounded-2xl border-2 border-brand-teal bg-brand-paper p-6 shadow-lg" data-id="element-26" data-mp="3e3z3svcxlvwr">
            <span className="-mt-10 inline-block rounded-full bg-brand-teal px-3 py-1 text-[10px] font-bold tracking-wide text-brand-deep" data-id="element-27" data-mp="3j0zan8hlv2ox">
              MÁS ELEGIDO
            </span>
            <h3 className="mt-4 font-display text-base font-bold leading-tight text-brand-ink" data-id="element-28" data-mp="fe8qtanclgsa">
              ATLAS DE GEOMETRÍA SAGRADA APLICADA AL CUERPO™
            </h3>
            <p className="mt-2 font-display text-3xl font-bold text-brand-violet" data-id="element-29" data-mp="kacj50nv1h45">
              {PRICE}
            </p>
            <p className="mt-4 text-sm leading-relaxed text-brand-muted" data-id="element-30" data-mp="g7ptn6enw8a4">
              3 Tomos + 6 Bonos · 150 páginas y 15+ protocolos clínicos. El
              sistema visual de geometría sagrada aplicada más completo en
              español.
            </p>
            <CTAButton fullWidth className="mt-6 py-3.5 text-sm" data-id="element-31" data-mp="1jlbc3jityrv">
              → QUIERO MI ATLAS DE GEOMETRÍA $27.990
            </CTAButton>
          </div>
          <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-brand-muted md:text-sm" data-id="element-32" data-mp="3sqfogzri2tpb">
            <span className="inline-flex items-center gap-1" data-id="element-33" data-mp="3oq5gxio27v8c">
              <LockKeyholeIcon className="h-4 w-4" data-id="element-34" data-mp="3jo6ecb0592cg" />
              Pago 100% seguro
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-35" data-mp="3er69u4iy07ng">
              <ZapIcon className="h-4 w-4" data-id="element-36" data-mp="1u8ck1rd8zfn1" />
              Acceso en 5 minutos
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-37" data-mp="1z773mvj1h887">
              <ShieldCheckIcon className="h-4 w-4" data-id="element-38" data-mp="1z5cet64ncvyu" />
              Garantía 7 días
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-39" data-mp="2471pulrvd9mx">
              <CreditCardIcon className="h-4 w-4" data-id="element-40" data-mp="28853r2qcwvli" />
              Mercado Pago | Tarjeta
            </span>
          </div>
          <div className="mt-8 rounded-2xl border border-brand-violet/25 bg-brand-surfaceLight/70 p-5 text-left text-sm leading-relaxed text-brand-text md:text-center" data-id="element-41" data-mp="1bj5xtud8w5wh">
            <p data-id="element-42" data-mp="1ki12v34jz9y7">
              <strong className="text-brand-ink" data-id="element-43" data-mp="1khhkjlazqjjn">P.D.:</strong> Si tenés dudas,
              escribinos a{' '}
              <a className="font-semibold text-brand-teal underline-offset-2 hover:underline" href="mailto:soportelumenakasha@gmail.com" data-id="element-44" data-mp="1pakhm3ez8b4l">
                soportelumenakasha@gmail.com
              </a>{' '}
              o por{' '}
              <a className="font-semibold text-brand-teal underline-offset-2 hover:underline" href="https://wa.me/5491153399780" data-id="element-45" data-mp="dp4y8fvsfnic">
                WhatsApp al 11 5339-9780
              </a>
              . Te respondemos hoy.
            </p>
            <p className="mt-3 italic text-brand-goldDark" data-id="element-46" data-mp="imn1bpn4j8if">
              El precio de lanzamiento sube pronto. El mejor momento para tener
              tu atlas clínico de geometría sagrada es ahora.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}